// extracted by mini-css-extract-plugin
var _1 = "Project_addButton__8ZAw8";
var _2 = "Project_addButtonIcon__+XY8r";
var _3 = "Project_board__Pwv7m";
var _4 = "Project_boardTitle__JJtDs";
var _5 = "Project_boardWrapper__UoK9V";
var _6 = "Project_boardsWrapper__gqvRY";
var _7 = "Project_boardsWrapperEmpty__bgHZ8";
var _8 = "Project_header__n3CNs";
var _9 = "Project_headerButton__oKANk";
var _a = "Project_headerButtonGroup__cMhiK";
var _b = "Project_headerDetails__1Dhu4";
var _c = "Project_headerText__Z+ggc";
var _d = "Project_info__wA3Be";
var _e = "Project_notification__w4Sek";
var _f = "Project_title__kdDy-";
var _10 = "Project_wrapper__XCZxv";
export { _1 as "addButton", _2 as "addButtonIcon", _3 as "board", _4 as "boardTitle", _5 as "boardWrapper", _6 as "boardsWrapper", _7 as "boardsWrapperEmpty", _8 as "header", _9 as "headerButton", _a as "headerButtonGroup", _b as "headerDetails", _c as "headerText", _d as "info", _e as "notification", _f as "title", _10 as "wrapper" }
